export enum NavPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  HIDDEN = '',
}

export enum MenubarPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  HIDDEN = '',
}
